import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { COLORS, FONTS, SPRING } from "./constants";
import { DemoBackdrop, glow } from "./shared";
import { RainbowEAKC } from "../shared/RainbowEAKC";

export const Scene01Title: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps, durationInFrames } = useVideoConfig();

  const fade = interpolate(frame, [durationInFrames - 30, durationInFrames], [1, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  const titleSp = spring({ frame, fps, config: SPRING.bouncy });
  const titleOp = interpolate(titleSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const titleScale = interpolate(titleSp, [0, 1], [0.5, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  const subSp = spring({ frame: frame - 30, fps, config: SPRING.gentle });
  const subOp = interpolate(subSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  const chipSp = spring({ frame: frame - 80, fps, config: SPRING.gentle });
  const chipOp = interpolate(chipSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  return (
    <AbsoluteFill style={{ background: COLORS.bg, opacity: fade, overflow: "hidden" }}>
      <DemoBackdrop frame={frame} accent={COLORS.neonCyan} />

      <div style={{
        position: "absolute", inset: 0,
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        gap: 24,
      }}>
        <RainbowEAKC
          id="pd-title"
          frame={frame}
          fontSize={200}
          fontFamily={FONTS.heading}
          scale={titleScale}
          opacity={titleOp}
          glowColor={COLORS.neonPurple}
        />
        <div style={{
          fontSize: 56,
          fontFamily: FONTS.heading,
          fontWeight: 800,
          color: COLORS.neonCyan,
          textShadow: glow(COLORS.neonCyan, true),
          opacity: subOp,
          letterSpacing: 2,
          marginTop: 10,
        }}>
          Product Demo
        </div>

        {/* Demo chapter chips preview */}
        <div style={{
          display: "flex", gap: 14,
          marginTop: 40,
          opacity: chipOp,
          flexWrap: "wrap",
          justifyContent: "center",
          maxWidth: 1500,
        }}>
          {[
            { n: "01", t: "Multi-source Search",  c: COLORS.neonPink },
            { n: "02", t: "Tenant Security",       c: COLORS.neonBlue },
            { n: "03", t: "Interactive Web",       c: COLORS.neonGreen },
            { n: "04", t: "Intent Routing",        c: COLORS.neonOrange },
            { n: "05", t: "Learning Paths",        c: COLORS.neonPurple },
            { n: "06", t: "Self-Hosting",          c: COLORS.neonYellow },
          ].map((ch, i) => {
            const sp = spring({ frame: frame - 100 - i * 6, fps, config: SPRING.bouncy });
            const op = interpolate(sp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
            const sc = interpolate(sp, [0, 1], [0.5, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
            return (
              <div key={ch.n} style={{
                opacity: op,
                transform: `scale(${sc})`,
                padding: "14px 24px",
                borderRadius: 14,
                background: `${ch.c}15`,
                border: `2px solid ${ch.c}`,
                display: "flex",
                alignItems: "center",
                gap: 12,
                boxShadow: glow(ch.c),
              }}>
                <span style={{
                  fontSize: 16,
                  fontFamily: FONTS.mono,
                  color: ch.c,
                  fontWeight: 900,
                  opacity: 0.7,
                }}>{ch.n}</span>
                <span style={{
                  fontSize: 22,
                  fontFamily: FONTS.heading,
                  fontWeight: 700,
                  color: ch.c,
                  textShadow: glow(ch.c),
                }}>{ch.t}</span>
              </div>
            );
          })}
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
